"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = remove;
exports.rename = rename;
exports.move = move;
exports.add = add;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _FolderFetch = require("../actions/FolderFetch");

var BASE_URI = 'filemanager/api/v2/folders';

function remove(folderId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.delete(BASE_URI + "/" + folderId);
}

function rename(folderId, newName) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  var URI = BASE_URI + "/" + folderId + "/move-folder";
  return httpClient.post(URI, {
    data: {
      name: newName
    }
  }).then(_FolderFetch.buildFolderFromAttrs);
}

function move(folderId, parentId) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  var URI = BASE_URI + "/" + folderId + "/move-folder";
  return httpClient.post(URI, {
    data: {
      parent_folder_id: parentId
    }
  }).then(_FolderFetch.buildFolderFromAttrs);
}

function add(folder) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  var folderData = {
    name: folder.name,
    parent_folder_id: folder.parentId
  };
  return httpClient.post(BASE_URI, {
    data: folderData
  }).then(_FolderFetch.buildFolderFromAttrs);
}